import { render, staticRenderFns } from "./VideosDestaque.vue?vue&type=template&id=02fd60c6&"
import script from "./VideosDestaque.vue?vue&type=script&lang=js&"
export * from "./VideosDestaque.vue?vue&type=script&lang=js&"
import style0 from "./VideosDestaque.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports